import React from "react";

import { generateEmojiGrid, getGameResultsTitle, getGameResultsIcon } from "../../../lib/game-helpers";
import CountdownToNextPuzzle from "../../CountdownToNextPuzzle";
import ShareScoreButton from "../../ShareScoreButton";
import BaseModal from "../BaseModal";
import { GameStatusContext } from "../../../providers/GameStatusProvider";
import { PuzzleDataContext } from "../../../providers/PuzzleDataProvider";
import { Button } from "../../ui/button";
import { Separator } from "../../ui/separator";
import OtherGamesList from "../../OtherGamesList";

function ViewResultsModal() {
  const { submittedGuesses, isGameWon, numMistakesUsed } = React.useContext(GameStatusContext);
  const { gameData } = React.useContext(PuzzleDataContext);

  return (
    <BaseModal
      icon={getGameResultsIcon(isGameWon)}
      title={getGameResultsTitle(isGameWon, numMistakesUsed)}
      trigger={
        <Button variant="submit" className="w-[166px]" children={"Ver resultados"} />
      }
      triggerAsChild
      triggerWrapperClassName="w-fit mx-auto"
      initiallyOpen={false}
      showActionButton={false}
    >
      <div className="flex flex-col place-content-center">
        <p className="text-center font-[600]">
          Seus palpites estão representados abaixo
        </p>
        <span className="text-center whitespace-pre mb-2">
          {"\n"}
          {generateEmojiGrid(gameData, submittedGuesses)}
        </span>
      </div>
      <ShareScoreButton className="my-3" />
      <CountdownToNextPuzzle />
      <Separator className="my-4" />
      <OtherGamesList />
    </BaseModal>
  );
}

export default ViewResultsModal;
